import { useCallback } from 'react';
import type { ReactNode } from 'react';
import { useBlocker } from 'react-router';
import type { BlockerFunction } from 'react-router';
import { useTranslation } from 'react-i18next';

import usePromptListener from '/business/shared/hooks/usePromptListener';

function PromptUploadListener({ children }: { children: ReactNode }) {
  const { promptWhen, promptMessage } = usePromptListener();
  const { t } = useTranslation();
  const unsavedCopy = t('shared:unsavedChanges');

  const handleBlockedNavigation = useCallback<BlockerFunction>(
    ({ currentLocation, nextLocation, historyAction }) => {
      if (nextLocation.pathname !== currentLocation.pathname && promptMessage && promptWhen) {
        if (window.confirm(unsavedCopy)) {
          promptMessage({ currentLocation, nextLocation, historyAction });
        }
      }
      return false;
    },
    [promptMessage, promptWhen, unsavedCopy],
  );

  useBlocker(handleBlockedNavigation);

  return <>{children}</>;
}

export default PromptUploadListener;
